import React from 'react';
import { Container } from 'semantic-ui-react';
import { flattenToAppURL } from '@plone/volto/helpers';
import { UniversalLink } from '@plone/volto/components';
import { SliderWrapper } from 'iovisit-theme/components';

const Body = (data) => {
  const imageSize = 'leadimage';
  const logoSize = 'preview';

  return data?.slides ? (
    <Container>
      <div
        className={`size-${data.size || 'l'} ${
          data.fullwidth ? 'full-width' : ''
        }`}
      >
        <SliderWrapper autoplay={data.autoplay} n_items={data?.slides?.length}>
          {data.slides.map((slide, index) => {
            const logoObj = slide.logo_icon?.[0];
            const logo = logoObj
              ? logoObj.image?.scales?.[logoSize]?.download ||
                logoObj['@id'] + '/@@images/image/' + logoSize
              : null;
            const logoUrl = logo ? flattenToAppURL(logo) : null;

            const imageObj = slide.image?.[0];
            const image = imageObj
              ? imageObj.image?.scales?.[imageSize]?.download ||
                imageObj['@id'] + '/@@images/image/' + imageSize
              : null;
            const imageUrl = image ? flattenToAppURL(image) : null;

            const video = slide.video?.[0];
            const videoUrl = video
              ? video.file?.download ?? video.getURL + '/@@download/file'
              : null;
            const videoMimeType =
              video?.file?.['content-type'] ?? video?.mime_type;

            return (
              <div className="single-slide-wrapper" key={index}>
                <div className="bg-wrapper">
                  {videoUrl ? (
                    <video
                      loop={true}
                      muted={true}
                      playsInline={true}
                      autoPlay={true}
                      poster={imageUrl}
                    >
                      <source
                        type={videoMimeType}
                        src={flattenToAppURL(videoUrl)}
                      />
                    </video>
                  ) : (
                    <img
                      alt=""
                      role="presentation"
                      src={imageUrl}
                      loading="lazy"
                    />
                  )}
                </div>
                <div className="text-overlay">
                  <Container>
                    <div className="text-overlay-content">
                      <div className="text-and-icon">
                        {logoUrl && (
                          <div className="logo-text">
                            <img
                              alt=""
                              role="presentation"
                              src={logoUrl}
                              loading="lazy"
                            />
                          </div>
                        )}

                        {slide.title && (
                          <div className="title" id={'title-' + index}>
                            {slide.href?.[0] && !slide.href_title ? (
                              <UniversalLink item={slide.href[0]}>
                                {slide.title}
                              </UniversalLink>
                            ) : (
                              <>{slide.title}</>
                            )}
                          </div>
                        )}
                      </div>
                      {slide.description && (
                        <div className="description">{slide.description}</div>
                      )}
                      {slide.href?.[0] && slide.href_title && (
                        <div className="link">
                          <UniversalLink
                            id={'slide-' + index}
                            className="ui button primary"
                            item={slide.href[0]}
                            aria-labelledby={`title-${index} slide-${index}`}
                          >
                            {slide.href_title}
                          </UniversalLink>
                        </div>
                      )}
                    </div>
                  </Container>
                </div>
              </div>
            );
          })}
        </SliderWrapper>
      </div>
    </Container>
  ) : null;
};
export default Body;
